// BeatLoader.js

import React from 'react';
import { BeatLoader as Loader } from 'react-spinners';

const BeatLoader = ({ loading,size="25px" }) => {
  return (
    <div className="loader-container">
      <Loader size={size} margin={2} color={'#FFA500'} loading={loading} />
    </div>
  );
};

export default BeatLoader;
